var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('NavigationMenu'),_c('HeroBanner'),_c('Services'),_c('ServiceBanners'),_c('Footer'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }